import { useState, useEffect } from 'react';

import axios from 'axios';
import routes from 'app/routes';

export default function useYearExperiences() {
  const [yearExperiences, setYearExperiences] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.year_experiences.index)
      .then((response) => {
        setYearExperiences(response.data.data);
      });
  }, []);

  return yearExperiences;
}
